module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/script-02-9e3d41d26bfe4d8451021678b0c7cde7.svg";